/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { ProfileSelectorProps } from "./types";

export type { ProfileSelectorProps } from "./types";

export default CustomPlatform.select<() => React.FC<ProfileSelectorProps>>({
  tv: () => require("./ProfileSelector.tv").default,
  web: () => require("./ProfileSelector.web").default,
  native: () => require("./ProfileSelector").default,
})();
